
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"flyout.title":"Abfragezweck","editButton.title":"Bearbeiten"},"en":{"flyout.title":"Purpose of request","editButton.title":"Edit"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();